"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNetworkError = exports.isApiError = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./lib/account/dtos"), exports);
tslib_1.__exportStar(require("./lib/approvers/dtos"), exports);
tslib_1.__exportStar(require("./lib/booking/dtos"), exports);
tslib_1.__exportStar(require("./lib/category-group/dtos"), exports);
tslib_1.__exportStar(require("./lib/collection-response"), exports);
tslib_1.__exportStar(require("./lib/common"), exports);
tslib_1.__exportStar(require("./lib/company/dtos"), exports);
tslib_1.__exportStar(require("./lib/core/hub-api-config"), exports);
tslib_1.__exportStar(require("./lib/custom-fields/dtos"), exports);
var error_utils_1 = require("./lib/error-utils");
Object.defineProperty(exports, "isApiError", {
  enumerable: true,
  get: function () {
    return error_utils_1.isApiError;
  }
});
Object.defineProperty(exports, "isNetworkError", {
  enumerable: true,
  get: function () {
    return error_utils_1.isNetworkError;
  }
});
tslib_1.__exportStar(require("./lib/project-group/dtos"), exports);
tslib_1.__exportStar(require("./lib/project/dtos"), exports);
tslib_1.__exportStar(require("./lib/resource-group/dtos"), exports);
tslib_1.__exportStar(require("./lib/resource/dtos"), exports);
tslib_1.__exportStar(require("./lib/survey/api"), exports);
tslib_1.__exportStar(require("./lib/survey/dtos"), exports);